const appRegistry = [
  { patterns: ["/Admin", "/Revenue", "/Bulk-Users", "/ManageVcc"], app: "helios" },

  { patterns: ["/analytics"], app: "kleio" },
];

export function getAppForPath(path) {
  
  for (const { patterns, app } of appRegistry) {
    if (
         patterns.some(
        (p) =>
          path === p || path.startsWith(p + "/") || path.startsWith(p + "?"),
      )
    ) {
      return app;
    }
  }
  return "sophos";
}

const IMMERSIVE_ROUTES = ["/analytics/chat"];
const HIDE_FOOTER_ROUTES = ["/Flight-Notification"];

export function isImmersivePath(path) {
  return IMMERSIVE_ROUTES.some(
    (p) => path === p || path.startsWith(p + "/") || path.startsWith(p + "?"),
  );
}

export function isFooterHiddenPath(path) {
  return HIDE_FOOTER_ROUTES.some((p) => path === p || path.startsWith(p + "/"));
}
